// extracted by mini-css-extract-plugin
module.exports = {"root":"root_3P1xs"};